import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ScrollToTop } from "@/components/site/ScrollToTop";
import Landing from "@/pages/Landing";
import Termos from "@/pages/Termos";
import Privacidade from "@/pages/Privacidade";
import Agendamento from "@/pages/Agendamento";
import Recursos from "@/pages/Recursos";
import Cadastro from "@/pages/Cadastro";
import Planos from "@/pages/Planos";
import AdminSuper from "@/pages/AdminSuper";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/privacidade" element={<Privacidade />} />
          <Route path="/servicos/:slug" element={<Agendamento />} />
          <Route path="/recursos" element={<Recursos />} />
          <Route path="/cadastro" element={<Cadastro />} />
          <Route path="/planos" element={<Planos />} />
          <Route path="/admin-super" element={<AdminSuper />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
